var HeaderHelper = /** @class */ (function () {
    function HeaderHelper() {
        /**
        * Header name for SDK usage
        */
        this.sdkVersionHeader = 'X-KC-SDKID';
    }
    /**
    * Header identifying SDK type & version for internal purposes of Kentico
    */
    HeaderHelper.prototype.getSdkIdHeader = function (info) {
        return {
            header: this.sdkVersionHeader,
            value: "".concat(info.host, ";").concat(info.name, ";").concat(info.version)
        };
    };
    return HeaderHelper;
}());
export { HeaderHelper };
export var headerHelper = new HeaderHelper();
//# sourceMappingURL=header.helper.js.map